import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';

const Awards = () => {
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Medals</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider calend">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Medals
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={['Bronze', 'Silver', 'Gold', 'special','Partawards']}
              currentClassName="active">
              <li><a href="#Bronze"> Bronze</a></li>
              <li><a href="#Silver"> Silver</a></li>
              <li><a href="#Gold">Gold</a></li>
              <li><a href="#special">Special Prize</a></li>
              <li><a href="#Partawards">Part Awards</a></li>

              
            </Scrollspy>
            
          </div>

        </div>
        <div className="main_lab_style">
          <section id="Awards">

            <h1 style={{ textAlign: 'center', fontFamily: '"Quicksand Bold"', fontSize: '54px' }}>
              AWARDS
            </h1>

            <p style={{ textAlign: 'center'}}>
              We have documented our project accomplishments on this page in accordance with the criteria for the iGEM medal
              
            </p>

            <br />
            <br />
            <div id="Bronze">

            
            <img style={{ width: '40%' }} src="https://static.igem.wiki/teams/4154/wiki/assets/bronze.png" alt="" />


            <div className="award">
                <b>Competition Deliverables</b>
                <br />
                We accomplished Wiki, Project Promotion Video, Team Presentation, Judging Form.
            </div>
            
            <div className="award">
                <b>Project Attributions:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/attributions">https://2022.igem.wiki/cityu-hongkong/attributions</a>)
                <br />
                We described the work of the team members and the assistance of other people.
            </div>

            <div className="award">
                <b>Project Description:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/description">https://2022.igem.wiki/cityu-hongkong/description</a>)
                <br />
                
                We described our project and explained the inspiration behind it.
            </div>


            <div className="award">
               <b>Contribution:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/contribution">https://2022.igem.wiki/cityu-hongkong/contribution</a>)
               <br />
                We documented our contribution to future iGEM teams by adding the new parts to the iGEM registry (nsrQ, nsrO, and AacuE; BioBrick names are BBa_K4154000, BBa_K4154001and BBa_K4154003, respectively). Additionally, we described that nsrQ can be used for catalysing the precursor of secalonic acids and enzyme nsrO can be replaced by AacuF for new secalonic acid derivatives.

            </div>
            <br />
            <br />
            </div>

            <div id="Silver">

            
            <img style={{width:'40%'}} src="https://static.igem.wiki/teams/4154/wiki/assets/silver.png" alt="" />
            
            <div className="award">
              <b>Engineering Success:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/engineering">https://2022.igem.wiki/cityu-hongkong/engineering</a>)
              <br />
              We have applied two engineering cycles to the project, including engineering the new biosynthetic pathway (cycle 1) and elucidating the anticancer property of the new secalonic acid analogues (cycle 2).

            </div>
            <div className="award">
              <b>Collaboration:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/collaborations">https://2022.igem.wiki/cityu-hongkong/collaborations</a>)
              <br />
                We described the collaborations we had with the Waterloo iGEM team, the NTHU iGEM team, the TecChihuahua iGEM team, and the HKUST iGEM team. As well as emphasized what we have learned from the interaction and how the feedback aided with refining our lab work and polished our final project.

            </div>
            <div className="award">
              <b>Human Practices:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/human-practices">https://2022.igem.wiki/cityu-hongkong/human-practices</a>)
              <br />
                There are two main concerns that we seek to solve: a social concern (people can’t afford the cost of cancer drugs) and environmental concern (many traditional cancer treatments rely on toxic reagents). Our public opinion survey supported our concerns as the majority of people prioritized affordability and low toxicity of cancer treatments amongst other factors. Furthermore, we additionally had an interview with an oncologist who provided us with information to make our project more feasible.
            </div>
            <div className="award">
              <b>Proposed Implementation:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/implementation">https://2022.igem.wiki/cityu-hongkong/implementation</a>)
              <br />
                We defined that the implementation of our project will be conducted mainly though the HK Tech 300 programme as well as the Ideation Programme. The safety and efficacy of our project were considered owing to the feedback we had received.

            </div>

            

            
            <br />
            <br />
            </div>
            <div id="Gold">

            
            <img style={{ width: '40%' }} src="https://static.igem.wiki/teams/4154/wiki/assets/gold.png" alt="" />

            <div className="award">
               <b>Integrated Human Practices:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/human-practices">https://2022.igem.wiki/cityu-hongkong/human-practices</a>)
              <br />
                Through our public opinion survey, interviews with experts in the field of oncology, microbiology, and medicine we realized that we must consider public acceptance and safety. We used our social media platforms and synthetic biology workshop to raise awareness on the benefits of our project. In terms of safety, we incorporated new in vitro testing techniques, and discovered the anti-cancer mechanism our novel synthesized compounds though in silico modelling as suggested by the experts we received feedback from.

            </div>
            <div className="award">
               <b>Project Modeling:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/model">https://2022.igem.wiki/cityu-hongkong/model</a>)
              <br />
                We successfully produced two novel tetrahydroxanthone (THX) dimers by constructing an unnatural biosynthetic pathway. To uncover the possible anticancer mechanism, an in silico modeling work was carried out. Utilizing the AutoDock Vina software, the interactions between the new THX dimers and the human topoisomerase I (Topo I) were investigated. The result not only shows that our compounds can bind strongly to Topo I but also interfere with the crucial catalytic residue, Lys-532. These modelling results were corroborated with our in vitro data and helped to lay the ground work for future mechanistic studies on the anticancer properties of the two novel THX dimers.

            </div>
            <div className="award">
               <b>Proof of Concept:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/proof-of-concept">https://2022.igem.wiki/cityu-hongkong/proof-of-concept</a>)
              <br />
                The goal of our CityU-SeCure team project was to genetically modify Aspergillus Oryzae by using the CRISPR-Cas9 method to produce novel compounds. Our concept was that these novel compounds could exhibit anticancer properties and develop as affordable non-toxic, and eco-friendly anticancer drugs. To prove the concept of our project in a relevant context, we did in vitro tests on cell lines to identify cytotoxicity. Through these experiments, we proved that the novel compounds exhibited relatively high anticancer activity which could be developed as the natural anticancer drugs in the future.
            </div>
            <div className="award">
               	<b>Partnership:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/partnership">https://2022.igem.wiki/cityu-hongkong/partnership</a>)
                <br />

                <p>We described our partnership with the CUHK-SBS iGEM team, ATREUS. After several fruitful meetings, the final results of the collaboration were #SynBioOTD ( <a href="https://www.instagram.com/explore/tags/synbiootd/?next=%2F">https://www.instagram.com/explore/tags/synbiootd/?next=%2F</a>) (mass iGEM collaboration), the Synbio &amp; iGEM 101 workshop for high school students, as well as Mutual Professor Connection. Both teams benefited by covering more audiences in both activities and by implementing technical advice received from professors.</p>
            </div>

            <div className="award">
               <b>Education and Communication:</b> (<a href="https://2022.igem.wiki/cityu-hongkong/communication">https://2022.igem.wiki/cityu-hongkong/communication</a>)
              <br />
                We conducted synthetic biology-related workshops, comics, and social media content. The first two activities included interactive and fun materials, discussions, and Q&A sessions so that we could have an open dialogue with the target audience (students of several countries’ High Schools). For the global audience, we used Instagram as a communication channel as well as Youtube to provide useful information on fungi and cancer treatments.
            </div>
            <br />
            <br />
            </div>

            <div id="special">
              <h1>
                Special Prize:
              </h1>
              <div className="award">
                <b>Best Education</b> (<a href="https://2022.igem.wiki/example/education">https://2022.igem.wiki/example/education</a>)

                <br />
                Our project fulfills the criteria for Best Education in various ways. To attract more audience, we have drawn comics about our topic and posted them on social media. The spread of information today is highly enhanced by social media. Therefore, by sharing easy-to-understand comics on social media, we have made the knowledge of synthetic biology more accessible to users of the Internet. Instagram was our communication channel to the public: educational posts, stories, and interactions, plus workshop and survey links. Our YouTube videos provide useful information the public requested from our survey: uses of fungi and cancer treatments. Our team has also held workshops with secondary schools to share the knowledge of synthetic biology in greater detail, not only in Hong Kong schools but also around the globe. Explaining a topic to the general audience requires a broad and deep understanding of its related information. The process of preparing for workshops allowed a better flow of knowledge between the team under the distribution of work. By answering questions from students, we have also done more comprehensive research about our blind spots in our knowledge of synthetic biology. At the same time, while preparing for presentations, we have learnt more about project management and public speaking.
                
              </div>
              <div className="award">
                <b>Best Integrated Human Practices</b> (<a href="https://2022.igem.wiki/example/human-practices">https://2022.igem.wiki/example/human-practices</a>)
                
                <br />
                Our team hopes to change cancer cell treatment by developing a fungal system to synthesize novel therapeutics. Our targets were to bypass the obstacles of cost affordability and, since toxic reagents are used in common types of anticancer drugs, to bypass environmental concern as well. From our public opinion survey, we gathered that people from different backgrounds perceive our project to affect them to certain extents. The majority are concerned with the possibility of suffering from cancer in the future and prioritize affordability and low toxicity of cancer treatments, amongst other factors. However, the same survey, together with interviews of experts in the fields of oncology, microbiology, and medicine, provided us with the insight that there is an issue with public acceptance, while experts are concerned about the safety. We used our social media platforms (Instagram, Youtube) to raise awareness of the benefits of our project and natural products. While the synthetic biology workshop we held with over 110 secondary school students from around the world helped us gain public acceptance among the younger generation, In terms of safety, we incorporated new in vitro testing techniques and discovered the anti-cancer mechanism of our novel synthesized compounds through in silico modelling as suggested by the experts we received feedback from.

              </div>
              <div className="award">

                <b>Best Model :</b> (<a href="https://2022.igem.wiki/example/model">https://2022.igem.wiki/example/model</a>)
                <br />
                We consider that our team is eligible for this prize since, in the past summer, wet-lab experiments conducted by the CityU iGEM team 2022 have successfully produced two novel tetrahydroxanthone (THX) dimers by constructing an unnatural biosynthetic pathway. In order to uncover the possible anticancer mechanism, in silico modeling work was carried out. Utilizing the AutoDock Vina software, the interactions between the new THX dimers and the human topoisomerase I (Topo I) were investigated. The result not only shows that our compounds can bind strongly to Topo I but also interfere with the crucial catalytic residue, Lys-532. These modelling results were corroborated with our in vitro data and helped to lay the groundwork for future mechanistic studies on the anticancer properties of the two novel THX dimers.
                
              </div>
              <div className="award">
                <b>Best Supporting Entrepreneurship:</b> (<a href="https://2022.igem.wiki/example/entrepreneurship">https://2022.igem.wiki/example/entrepreneurship</a>)
                <br />
                One of the primary goals of the iGEM competition and our team is to work towards solving some of the most prominent global problems using synthetic biology. And we believe that the rising cases of drug-resistant diseases have established it among the most urgent issues of the coming few years. Through our research, we want to be able to actively contribute to combating these diseases by expanding the therapeutic library available to humanity. Taking the first step towards our goal, we presented our project to investors from the HKTECH300 startup competition. While enlightening them on the real-world applications of our project, we introduced them to a large market in natural-product-based therapeutics. We were awarded HK$ 100,000 as a seed fund as well as entry into the HK$ 1 million angel fund round for the subsequent year. While we are in the process of applying for a patent, we secured a spot in the Hong Kong Science and Technology Park Ideation Programme for start-ups to continue to research and develop our product. Considering our long- and short-term entrepreneurial goals and our drive to have a real-world impact, we are deserving of the best-supporting entrepreneurship award.
                
              </div>
              <div className="award">
                <b>Safety and Security Award:</b> (<a href="https://2022.igem.wiki/example/entrepreneurship">https://2022.igem.wiki/example/entrepreneurship</a>)
                <br />
                Our team is eligible for this prize since all the safety measures were implemented to minimize project risk. We have chosen parts that don’t harm humans. The departmental safety officer was ready to consult us and the biological protection officer was prepared to be approached if a hazard or risk was detected. Biosafety measures such as accident reporting, wearing PPE were implemented to manage project risks. Moreover, team members received safety training before doing project lab work and they were required to wear protective gloves, safety goggles, and face shields when performing experiments. Hazardous chemicals were stored in a well-ventilated area.

              </div>
              
            </div>


            <div id="Partawards">
              <h1>
                Part Awards:
              </h1>
              <div className="award">
               <b> Best New Basic Part</b> (<a href="https://2022.igem.wiki/cityu-hongkong/parts">https://2022.igem.wiki/cityu-hongkong/parts</a>)

                <br />
               <b> BBa_K4154001</b> (<a href="http://parts.igem.org/Part:BBa_K4154001">http://parts.igem.org/Part:BBa_K4154001</a>)


              </div>
              <div className="award">
               <b> Best New Composite Part</b> (<a href="https://2022.igem.wiki/cityu-hongkong/parts">https://2022.igem.wiki/cityu-hongkong/parts</a>)

                <br />
               <b> BBa_K4154006</b> (<a href="http://parts.igem.org/Part:BBa_K4154006">http://parts.igem.org/Part:BBa_K4154006</a>)

              </div>

            </div>

          </section>
        </div>
      </section>
    </div>
  );
}

export default Awards;
